export var AppointmentSource;
(function (AppointmentSource) {
    AppointmentSource["CallbackRequest"] = "CALLBACK_REQUEST";
    AppointmentSource["NoAppointmentAvailabilities"] = "NO_APPOINTMENT_AVAILABILITIES";
})(AppointmentSource || (AppointmentSource = {}));
//# sourceMappingURL=index.js.map